import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: true,
    name: 'futureStatus',
})
export class FutureStatusPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        const application = value;
        let status: string;
        if (application) {
            // status = application.states === 'Reserved' &&
            //   (application.program.requiredpostdocumentlist.requireContract === false && !application.signedcontract) ? 'Sign Agreement1' :
            //   status = application.states === 'Reserved' && (application.program.requiredpostdocumentlist.requireContract === true && !application.signedcontract) ? 'Sign Agreement2' :
            //   status = application.states === 'Reserved' && (application.program.requiredpostdocumentlist.default && !application.signedcontract) ? 'Sign Agreement3' :
            if (application.program) {
                status =
                    application.states === 'Reserved' && application.enrollable
                        ? 'Enrollment-Pending'
                        : application.states === 'Reserved'
                        ? 'Complete Application'
                        : application.states === 'Enrolled' && moment().isAfter(moment(application.enddate))
                        ? 'Submit Review'
                        : application.states === 'Accepted' && application.madedeposit === false
                        ? 'Pay and Reserve'
                        : application.states === 'Pending' && application.program.preapprovalrequired === true
                        ? 'Pay & Upload Documents'
                        : application.states === 'Pre-Approved'
                        ? 'Pay & Upload Documents'
                        : application.states === 'Pending' && application.program.preapprovalrequired === false
                        ? 'Pay and Reserve'
                        : application.states === 'Enrolled' && moment().isBefore(moment(application.enddate))
                        ? 'View Application'
                        : application.states === 'Enrolled' && moment().isAfter(moment(application.enddate))
                        ? 'Submit your review'
                        : application.states === 'Pending-Booked'
                        ? 'Application in Review'
                        : application.states;
            } else if (application.Program) {
                status =
                    application.states === 'Reserved' && application.enrollable
                        ? 'Enrollment-Pending'
                        : application.states === 'Reserved'
                        ? 'Complete Application'
                        : application.states === 'Enrolled' && moment().isAfter(moment(application.enddate))
                        ? 'Submit Review'
                        : application.states === 'Accepted' && application.madedeposit === false
                        ? 'Pay and Reserve'
                        : application.states === 'Pending' && application.Program.preapprovalrequired === true
                        ? 'Pay & Upload Documents'
                        : application.states === 'Pre-Approved'
                        ? 'Pay & Upload Documents'
                        : application.states === 'Pending' && application.Program.preapprovalrequired === false
                        ? 'Pay and Reserve'
                        : application.states === 'Enrolled' && moment().isBefore(moment(application.enddate))
                        ? 'View Application'
                        : application.states === 'Enrolled' && moment().isAfter(moment(application.enddate))
                        ? 'Submit your review'
                        : application.states === 'Pending-Booked'
                        ? 'Application in Review'
                        : application.states;
            }

            return status;
        }
    }
}
